import { format, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date) {
  if (!date) {
    return 'n/a';
  }
  return format(new Date(date), 'MM/dd/yyyy h:mm a');
}

export function fDateTimeSuffix(date) {
  const parsedDate = safeParseDateISO(date);
  if (parsedDate) {
    return format(parsedDate, 'MM/dd/yyyy p');
  }
  return 'n/a';
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}

export function elapsedTimeToStr(elapsedTime) {
  // retrieves a string representation of the elapsed time in d/h/m/s
  if (elapsedTime) {
    const seconds = Number(elapsedTime);
    const d = Math.floor(seconds / (3600 * 24));
    const h = Math.floor((seconds % (3600 * 24)) / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);

    const dDisplay = d > 0 ? `${d}d ` : '';
    const hDisplay = h > 0 ? `${h}h ` : '';
    const mDisplay = m > 0 ? `${m}m ` : '';
    const sDisplay = s > 0 ? `${s}s ` : '';
    return dDisplay + hDisplay + mDisplay + sDisplay;
  }
  return 'N/A';
}

export function getElapsedSeconds(unixTime) {
  // retrieves a second representation of elapsed time since the provided unix time
  if (unixTime) {
    return Date.now() / 1000 - unixTime;
  }
  return -1;
}

export function safeParseDateISO(dateString) {
  // if input is not a string return null
  if (!dateString || typeof dateString !== 'string') {
    return null;
  }
  // convert non-iso date string to iso by removing UTC, replacing the post-date space with T and removing the space after time
  const isoString = dateString.replace(' ', 'T').replace(' UTC', '').replace(' +', '+').trim();
  // create date
  const date = new Date(isoString);
  // if date is not a number return null, otherwise return date
  return Number.isNaN(date.getTime()) ? null : date;
}

export function secondsToDateStr(seconds) {
  if (seconds === undefined || seconds === null) {
    return 'n/a';
  }
  const targetDate = new Date(Date.now() + seconds * 1000);
  return format(targetDate, 'MM/dd/yyyy');
}

// Parse date string "MM/DD/YYYY" into a Date for sorting.
export const parseDate = (date) => {
  const [month, day, year] = date.split('/');
  return new Date(year, month - 1, day);
};
